module.exports = __webpack_public_path__ + "media/images/banner5-b78d2254dfb60f6efd1e1cec05277ceb.jpg";